export const columns = [
  {
    column: {
      Header: 'AssetId',
      accessor: 'AssetID',
      resizable: true,
      filterable: true,
      type: 'number',
    },
    type: 'number',
  },
  {
    column: {
      Header: 'Barcode',
      accessor: 'BarCode',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description',
      accessor: 'Description',
      resizable: true,
      width: 200,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description2',
      accessor: 'Description2',
      resizable: true,
      width: 200,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description3',
      accessor: 'Description3',
      resizable: true,
      width: 200,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Asset Number',
      accessor: 'AssetNumber',
      resizable: true,
      // width: 400,
      type: 'number',
    },
    type: 'number',
  },
  {
    column: {
      Header: 'Owner',
      resizable: true,
      accessor: 'Owner',
      // width: 400,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Acquired',
      accessor: 'Acquired',
      resizable: true,
      // width: 400,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Year',
      accessor: 'Year',
      resizable: true,
      // width: 400,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Department',
      accessor: 'Department',
      resizable: true,
      // width: 400,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Serial #',
      accessor: 'SerialNumber',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
];

export const filterButtons = [];  // None needed yet

